// extracted by mini-css-extract-plugin
export default {"heartFollow":"HeartButton-module__heartFollow___tnSO0","heart":"HeartButton-module__heart___S3uSQ"};